import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../utils/apk";
import { useLocation } from "react-router-dom";

const ConfirmedOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(() => {
    // Default to today's date in YYYY-MM-DD format
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  const location = useLocation();

  const fetchOrders = async (date) => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/get/all/delivered/order`, {
        params: { date },
      });

      if (response.data && response.data.success) {
        const revOrders = response.data.data.reverse();
        console.log("✅ Full API Response:", response);
        console.log("📦 Delivered Orders (Reversed):", revOrders);
        setOrders(revOrders);
      } else {
        console.warn("⚠️ API call succeeded but returned failure status.");
        setOrders([]);
      }
    } catch (error) {
      console.error("❌ Error fetching orders:", error);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders(selectedDate);
  }, [location, selectedDate]);

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Delivered Orders</h1>

        <div>
          <input
            type="date"
            className="border px-3 py-1 rounded shadow-sm text-gray-700"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="loader">Loading...</div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {orders.length === 0 ? (
            <p className="text-center text-gray-500 col-span-full">
              No delivered orders found for {selectedDate}.
            </p>
          ) : (
            orders.map((order) => (
              <div
                key={order._id}
                className="bg-white shadow-lg rounded-lg p-4 border border-gray-200"
              >
                <h2 className="text-xl font-semibold">
                  Order ID: {order.orderId?.orderId}
                </h2>

                <p className="text-gray-600">
                  Total Price: ₹{order.orderId?.totalPrice}
                </p>

                <p className="text-gray-600">
                  Customer Name: {order.orderId?.userAddress?.name || "N/A"}
                </p>

                <p className="text-gray-600">
                  Delivery Boy Name: {order?.deliveryBoyId?.name || "N/A"}
                </p>

                <p className="text-gray-600">
                  Delivery Boy Mobile: {order?.deliveryBoyId?.mobileNo || "N/A"}
                </p>

                <div className="mt-2">
                  <h3 className="font-bold">Items:</h3>
                  {order.orderId?.addToCart?.cartIds?.map((item) => (
                    <div
                      key={item._id}
                      className="flex items-center justify-between my-2 border-b py-2"
                    >
                      <div className="ml-2">
                        <p className="font-semibold">{item.itemName}</p>
<p className="text-gray-500">
  Price: ₹{
    Number(item.increasedPrice) > 0 
      ? Number(item.increasedPrice).toFixed(2)
      : Number(item.itemRate).toFixed(2)
  }
</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default ConfirmedOrders;
